import React from "react";
import { string, number, arrayOf, bool, shape } from "prop-types";
import * as i18n from "util/i18n";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import InfoTag from "pages/echeck/components/InfoTag";
import { statusTagColor } from "util/cedip";

const CedipDetailList = ({ isDesktop, cedip }) => (
    <GridTable className="deposit-details-list details">
        <GridTable.Container key={cedip.idProduct} columns={isDesktop ? 3 : 1} rows={isDesktop ? 2 : 11}>
            <GridTable.Data columnStart={1} rowStart={1}>
                <CustomData
                    titleText="cedip.details.type.accreditation"
                    titleTextType="I18N"
                    titleClass="text-Primary-primary-color"
                    valueText={i18n.get(`cedip.type.accreditation.${cedip.tipoAcreditacion}`)}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            {!isDesktop && (
                <GridTable.Data columnStart={2} rowStart={1}>
                    <InfoTag type="info" message={cedip.estado} tagBackground={statusTagColor(cedip.estado)} />
                </GridTable.Data>
            )}
            <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                <CustomData
                    titleText="cedip.details.currency"
                    titleTextType="I18N"
                    valueText={i18n.get(`account.agreement.currency.${cedip.tipoMoneda}`)}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3}>
                <CustomData
                    titleText="cedip.details.date.constitution"
                    titleTextType="I18N"
                    valueText={cedip.fechaEmision}
                    valueTextType="DATE"
                />
            </GridTable.Data>
            <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 4}>
                <CustomData
                    titleText="cedip.details.date.expired"
                    titleTextType="I18N"
                    valueText={cedip.fechaVencimiento}
                    valueTextType="DATE"
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 2 : 5}>
                <CustomData
                    titleText="cedip.details.automatic.renewal"
                    titleTextType="I18N"
                    valueText={cedip.tipoRenovacion}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 2 : 6}>
                <CustomData
                    titleText="cedip.details.nominal.rate"
                    titleTextType="I18N"
                    valueText={cedip.tna}
                    valueTextType="PERCENTAGE"
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 1 : 1} rowStart={isDesktop ? 3 : 7}>
                <CustomData
                    titleText="cedip.details.term"
                    titleTextType="I18N"
                    valueText={
                        <>
                            <span>{cedip.plazo}</span>
                            <span> </span>
                            <span>{i18n.get("global.days.label")}</span>
                        </>
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 3 : 8}>
                <CustomData
                    titleText="cedip.details.capital.invested"
                    titleTextType="I18N"
                    valueText={<FormattedAmount currency={cedip.tipoMoneda} quantity={cedip.montoDepositado} />}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            {/* <GridTable.Data columnStart={1} columnWidth={isDesktop && 3} rowStart={isDesktop ? 4 : 9}>
                <hr className="dotted" />
            </GridTable.Data>
            <GridTable.Data columnStart={1} rowStart={isDesktop ? 5 : 10}>
                <CustomData
                    titleText="cedip.details.holder.name"
                    titleTextType="I18N"
                    valueText={cedip.tenedorNombre}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 2 : 1} columnWidth={isDesktop && 3} rowStart={isDesktop ? 5 : 11}>
                <CustomData
                    titleText="cedip.details.cbu.accredit"
                    titleTextType="I18N"
                    valueText={cedip.cbuAacreditar}
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 5 : 12}>
                <CustomData
                    titleText="cedip.details.accreditation.date"
                    titleTextType="I18N"
                    valueText={cedip.fechaAcreditacionRechazo}
                    valueTextType="DATE"
                />
            </GridTable.Data> */}
        </GridTable.Container>
    </GridTable>
);
CedipDetailList.propTypes = {
    cedip: arrayOf(
        shape({
            tipoAcreditacion: string.isRequired,
            tipoMoneda: string.isRequired,
            fechaEmision: string,
            fechaVencimiento: string,
            tipoRenovacion: string,
            tna: number,
            plazo: number,
            tenedorNombre: string,
            cbuAacreditar: string,
            fechaAcreditacionRechazo: string,
        }),
    ).isRequired,
    isDesktop: bool,
};

CedipDetailList.defaultProps = { isDesktop: bool };

export default CedipDetailList;
